import type { CustomDataMap, DatapointOptions } from "owa-analytics-types";
import type { MailboxInfo } from "owa-client-types";
import { AriaDatapoint } from "./AriaDatapoint";

export class UsageCoreDatapoint extends AriaDatapoint {
    constructor(eventName: string, mailbox: MailboxInfo | undefined, customData?: CustomDataMap, options?: DatapointOptions) {
        super(eventName, mailbox, customData, options);
        this.options = { ...this.options, isCore: true };
    }
}
